import axios from 'axios'
import authHeader from './auth-header'
import Config from '../../config'
import Vue from "vue";

if (localStorage.getItem('gpsServers')) {
  Vue.prototype.$gpsServers = JSON.parse(localStorage.getItem('gpsServers'))
} else {
  Vue.prototype.$gpsServers = Config.gpsServers
}
if (localStorage.getItem('apiServers')) {
  Vue.prototype.$apiServers = JSON.parse(localStorage.getItem('apiServers'))
} else {
  Vue.prototype.$apiServers = Config.apiServers
}
const serverAddress = `${Vue.prototype.$apiServers.url}`

class CustomerService {
  // eslint-disable-next-line class-methods-use-this
  getAll(payload) {
    // eslint-disable-next-line no-underscore-dangle
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/customer/list`, payload, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  getById(payload) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/customer/byId`, { id: payload.id }, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  addManager(payload) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/customer/addManager`, payload, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  removeManager(payload) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/customer/removeManager`, payload, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  impersonate(payload) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/impersonate/start`, payload, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  endImpersonation() {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/impersonate/end`, {}, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  addAgent(payload) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/customer/addAgent`, payload, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // ساخت مستقیم نماینده (کاربر جدید با type=1)
  // eslint-disable-next-line class-methods-use-this
  addAgentUser(payload) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/customer/addAgentUser`, payload, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  addUser(payload) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/customer/addUser`, payload, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  removeAgent(payload) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/customer/removeAgent`, payload, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  edit(payload) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/customer/edit`, payload, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  delete(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/customer/removeUser`,
      {
        _id: data.userId,
        companyId: data.companyId,
      }, {
        headers: authHeader(),
      })
    return promise.then(response => response.data)
  }
}

export default new CustomerService()
